import { Utils } from 'mw-style-react';
import utilsHtml from './modules/utilsHtml';
import utilsDate from './modules/utilsDate';
import utilsFilter from './modules/utilsFilter';
import utilsAccess from './modules/utilsAccess';
import utilsArray from './modules/utilsArray';
import utilsRandom from './modules/utilsRandom';
import utilsKeyboard from './modules/utilsKeyboard';
import transliterateMap from './modules/transliterateMap.json';
import similarText from './modules/similarText';
import utilsCanvas from './modules/utilsCanvas';
import utilsSmartChips from './modules/utilsSmartChips';

/**
 * Утилиты
 */
const AppUtils = {
  // Получить сообщение локализации
  getMes(context) {
    const ct = context.intl;
    return function res(mesId, values) {
      try {
        return ct.formatMessage(mesId, values);
      } catch (e) {
        return mesId;
      }
    };
  },

  // Ф-ция формирования url запроса
  makeAppUrl(url, queryParams = {}) {
    const apiVersion = '1.0';
    url = `/api/${apiVersion}${url}`;
    return AppUtils.makeUrl(url, { ...queryParams });
  },

  // Сформировать url с get параметрами
  makeUrl(url, params) {
    if (!params || !Object.keys(params).length) return url;
    const divider = url.includes('?') ? '&' : '?';
    return `${url}${divider}${Utils.serialize(params)}`;
  },

  getAccountId(pathname) {
    const pathParts = pathname.split('/');
    return pathParts[2];
  },

  makeShortAccountId(acccountId) {
    if (!acccountId) return '0';
    return acccountId.split('-')[0];
  },

  getProcessIdFromDirectUrl(directUrl) {
    return directUrl
      ? directUrl.split('/api/1/json/public/')[1].split('/')[0]
      : '';
  },

  createAndDownloadJson(filename, data) {
    const element = document.createElement('a');
    element.setAttribute(
      'href',
      `data:application/json;charset=utf-8,${JSON.stringify(data, null, 2)}`
    );
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  },

  transliterate(word) {
    return word
      .split('')
      .map((char) => transliterateMap[char] || char)
      .join('');
  },

  isUndefined(value) {
    return typeof value === 'undefined' || value === null || value.length === 0;
  },

  isNumeric(n) {
    return !Number.isNaN(parseFloat(n)) && Number.isFinite(n);
  },

  toBool(val) {
    return val === 'true' || val === true;
  },

  isEmptyObject(obj) {
    return !obj || Object.keys(obj).length === 0;
  },

  isJSON(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  },

  isDebug(url) {
    const qParams = Utils.getQueryParam(url);
    return !!qParams.debug;
  },

  isIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  },

  isMobile() {
    const { userAgent, platform, maxTouchPoints } = navigator;
    // eslint-disable-next-line max-len
    return (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
        userAgent
      ) ||
      (/MacIntel/.test(platform) && maxTouchPoints && maxTouchPoints > 2)
    );
  },

  toNumberFormat(number, locale = 'ru-RU') {
    const formatter = new Intl.NumberFormat(locale);
    return formatter.format(number);
  },

  toCamelCase(str) {
    const camelCase = str.replace(/_([a-zA-Z])/g, (m, w) => w.toUpperCase());
    return camelCase.charAt(0).toLowerCase() + camelCase.slice(1);
  },

  // Сделать имутабельный сложный объект
  deepFreeze(obj) {
    // извлекаем свойства, определенное в obj
    const propNames = Object.getOwnPropertyNames(obj);
    // прежде чем заморозить сам объект, замораживаем свойства отдельно
    propNames.forEach((name) => {
      const prop = obj[name];
      // замораживаем prop, если он является объектом
      if (typeof prop === 'object' && prop !== null) {
        this.deepFreeze(prop);
      }
    });
    // замораживаем сам объект
    return Object.freeze(obj);
  },
  isPublicScript() {
    return /script\/.*?\/view_public/.test(location.pathname);
  },
};

export default Object.assign(
  AppUtils,
  utilsHtml,
  utilsDate,
  utilsFilter,
  utilsArray,
  utilsRandom,
  utilsKeyboard,
  utilsAccess,
  similarText,
  utilsCanvas,
  utilsSmartChips
);
